import { Container } from '@material-ui/core'
import React from 'react'

const Blog = () => {
  return (
    <>
    <Container align='center'>
        
    </Container>
    </>
  )
}

export default Blog